import React from 'react'
import PropTypes from 'prop-types'
import {
  TableRow as MuiTableRow,
  TableFooter as MuiTableFooter,
  TablePagination as MuiTablePagination,
} from '@mui/material'

import { withStyles } from '@mui/styles'

const defaultPaginationStyles = {
  root: {
    fontSize: '1.4rem !important',
    '&:last-child': {
      padding: '0px 24px 0px 24px',
    },
    backgroundColor: '#E8E8E8',
    color: '#424242',
  },
  toolbar: {},
  selectRoot: {
    paddingRight: '8px',
  },
  '@media screen and (max-width: 400px)': {
    toolbar: {
      '& span:nth-child(2)': {
        display: 'none',
      },
    },
    selectRoot: {
      marginRight: '8px',
      paddingRight: '8px',
    },
  },
  caption: {
    fontSize: 14,
  },
}

const TablePagination = (props) => {
  const {
    count,
    classes,
    options,
    rowsPerPage,
    page,
    changePage,
    changeRowsPerPage,
  } = props
  
  const handleRowChange = (event) => {
    changeRowsPerPage(event.target.value)
  }

  const handlePageChange = (_, pageNumber) => {
    changePage(pageNumber)
  }

  const textLabels = {
    pagination: {
      next: 'Próxima página',
      previous: 'Página anterior',
      rowsPerPage: 'Linhas por página:',
      displayRows: 'de',
    },
  }

  return (
    <MuiTableFooter>
      <MuiTableRow>
        <MuiTablePagination
          className={classes.root}
          classes={{
            caption: classes.caption,
            toolbar: classes.toolbar,
            selectRoot: classes.selectRoot,
          }}
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          labelRowsPerPage={textLabels.pagination.rowsPerPage}
          labelDisplayedRows={({ from, to, count: countNumber }) =>
            `${from}-${to} ${textLabels.pagination.displayRows} ${countNumber}`
          }
          backIconButtonProps={{
            id: 'pagination-back',
            'aria-label': textLabels.previous,
          }}
          nextIconButtonProps={{
            id: 'pagination-next',
            'aria-label': textLabels.next,
          }}
          SelectProps={{
            id: 'pagination-input',
            SelectDisplayProps: { id: 'pagination-rows' },
            MenuProps: {
              id: 'pagination-menu',
              MenuListProps: { id: 'pagination-menu-list' },
            },
          }}
          rowsPerPageOptions={options.rowsPerPageOptions}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowChange}
        />
      </MuiTableRow>
    </MuiTableFooter>
  )
}

TablePagination.propTypes = {
  /** Total number of table rows */
  count: PropTypes.number.isRequired,
  /** Options used to describe table */
  options: PropTypes.object.isRequired,
  /** Current page index */
  page: PropTypes.number.isRequired,
  /** Total number allowed of rows per page */
  rowsPerPage: PropTypes.number.isRequired,
  /** Callback to trigger rows per page change */
  changeRowsPerPage: PropTypes.func.isRequired,
}

export default withStyles(defaultPaginationStyles, {
  name: 'MUIDataTablePagination',
})(TablePagination)
